import React from "react";
import { Fieldset } from "gold-ui-kit";

const GroupBox = ({ title, children, className = "" }) => (
  <Fieldset title={title} className={className}>
    {children}
  </Fieldset>
);

export default GroupBox;
